"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Vendors
 */
require("picturefill");
require("lazysizes");
require("./vendor/ls.object-fit");
require("./utils/form-submission");
// import { library, dom } from "@fortawesome/fontawesome-svg-core";
// import {
//   faChevronDown,
//   faCommentDots,
// } from "@fortawesome/free-solid-svg-icons";
// library.add(faChevronDown, faCommentDots);
// dom.watch();
/**
 * Import Functions
 */
const global_1 = require("./functions/global");
const navMain_1 = require("./functions/navMain");
const mobileNav_1 = require("./functions/mobileNav");
const mobileNavSub_1 = require("./functions/mobileNavSub");
const sliders_1 = require("./functions/sliders");
const accordion_1 = require("./functions/accordion");
const ajaxFilter_1 = require("./functions/ajaxFilter");
const datepicker_js_1 = require("./functions/datepicker.js");
const formBlock_1 = require("./functions/formBlock");
const forms_js_1 = require("./functions/forms.js");
const searchToggle_1 = require("./functions/searchToggle");
const parallax_1 = require("./functions/parallax");
const animateIn_1 = require("./functions/animateIn");
const translateStyles_1 = require("./functions/translateStyles");
const modal_1 = require("./functions/modal");
const searchHighlight_1 = require("./functions/searchHighlight");
const maintenanceMap_js_1 = require("./functions/maintenanceMap.js");
const tagManagerEvents_js_1 = require("./functions/tagManagerEvents.js");
const logosGrid_js_1 = require("./functions/logosGrid.js");
const dropdown_card_1 = require("./functions/dropdown-card");
/**
 * Call Functions
 */
(0, global_1.global)();
(0, global_1.accessibility)();
(0, navMain_1.navMain)();
// stickyHeader()
(0, parallax_1.parallax)();
(0, animateIn_1.animateIn)();
(0, mobileNav_1.mobileNav)();
(0, mobileNavSub_1.mobileNavSub)();
(0, tagManagerEvents_js_1.tagManagerEvents)();
(0, sliders_1.sliders)();
(0, accordion_1.accordion)();
(0, ajaxFilter_1.ajaxFilter)();
(0, datepicker_js_1.default)();
(0, searchToggle_1.searchToggle)();
(0, translateStyles_1.translateStyles)();
(0, searchHighlight_1.searchHighlight)();
(0, modal_1.modal)();
(0, formBlock_1.formBlock)();
(0, forms_js_1.default)();
(0, maintenanceMap_js_1.maintenanceMap)();
(0, logosGrid_js_1.logosGrid)();
new dropdown_card_1.default();
